module.exports = __webpack_public_path__ + "img/chinesecompany55.096d17b4.png";